import React, { useEffect, useState, useRef } from "react";
import CustomTable from "../../components/Table";
import Header from "../../components/Header";
import { MASTER_URL } from "../../common/common";
import AdminCointainer from "../../containers/Admin";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/AddButton";
import { Plus, routes } from "../../common/svg";
import { ApiService } from "../../service/api.service";
import ToggleSwitch from "../../components/ToggleSwitch/ToggleSwitch";
import ToggleActive from "../../components/ToggleSwitch/ToggleActive";

type RouteData = {
  routeId: string;
  routeName: string;
  pickupPoint: string;
  loadingPoint: string;
  unloadingPoint: string;
  clearancePoint: string;
  isActive: boolean;
};

type Column<T> = {
  header: string;
  dataKey: keyof T;
  render?: (value: T[keyof T], row: T) => React.ReactNode;
  align?: "left" | "center" | "right";
};

const RoutesPage = () => {
  const navigate = useNavigate();
  const apiService = new ApiService();
  const [routesData, setRoutesData] = useState<RouteData[]>([]);
  const [search, setSearch] = useState<string>("");
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const entityId = localStorage.getItem('entity_id');
  const menuRef = useRef<HTMLDivElement>(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [active, setActive] = useState<boolean>(true);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setActiveMenu(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggleActive = async (routeId: string, isActive: boolean) => {
    try {
      const response: any = await apiService.putApi(
        `${MASTER_URL}/route/status-route`,
        {
          routeId: routeId,
          isActive: isActive ? 1 : 0
        }
      );

      if (response.status === "200") {
        getRoutesData();
        setRoutesData(prevData =>
          prevData.map(route =>
            route.routeId === routeId ? { ...route, isActive } : route
          )
        );
      }
    } catch (error) {
      console.error("Error updating route status:", error);
    }
  };

  const columns: Column<RouteData>[] = [
    { header: "Route Name", dataKey: "routeName" },
    {
      header: "Pickup Point",
      dataKey: "pickupPoint",
      render: (value: string | boolean | undefined) => (
        <div className="text-sm text-left leading-relaxed">
          {typeof value === 'string' ? value.split("\n").map((line, i) => (
            <div key={i}>{line}</div>
          )) : null}
        </div>
      ),
    },
    {
      header: "Loading Point",
      dataKey: "loadingPoint",
      render: (value: string | boolean | undefined) => (
        <div className="text-sm text-left leading-relaxed">
          {typeof value === 'string' ? value.split("\n").map((line, i) => (
            <div key={i}>{line}</div>
          )) : null}
        </div>
      ),
    },
    {
      header: "Unloading Point",
      dataKey: "unloadingPoint",
      render: (value: string | boolean | undefined) => (
        <div className="text-sm text-left leading-relaxed">
          {typeof value === 'string' ? value.split("\n").map((line, i) => (
            <div key={i}>{line}</div>
          )) : null}
        </div>
      ),
    },
    {
      header: "Clearance Point",
      dataKey: "clearancePoint",
      render: (value: string | boolean | undefined) => (
        <div className="text-sm text-left leading-relaxed">
          {typeof value === 'string' ? value.split("\n").map((line, i) => (
            <div key={i}>{line}</div>
          )) : null}
        </div>
      ),

    },
    {
      header: "Status",
      dataKey: "isActive",
      render: (value: string | boolean | undefined) => {
        let status: string | null = null;

        if (typeof value === "boolean") {
          status = value ? "Active" : "Inactive";
        } else if (typeof value === "string") {
          if (value === "1") {
            status = "Active";
          } else if (value === "0") {
            status = "Inactive";
          } else {
            return (
              <div>
                {value
                  .split("\n")
                  .map((line, i) => <div key={i}>{line}</div>)}
              </div>
            );
          }
        }

        return <div>{status}</div>;
      }
    },
    // {
    //   header: "Actions",
    //   dataKey: "routeId",
    //   align: "center",
    //   render: (value, row) => (
    //     <div
    //       className="relative ml-2"
    //       ref={activeMenu === value ? menuRef : null}
    //       onClick={(e) => e.stopPropagation()}
    //     >
    //       <button 
    //         className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100"
    //         onClick={(e) => {
    //           e.stopPropagation();
    //           setActiveMenu(activeMenu === value ? null : (value as string | null));
    //         }}
    //       >
    //         <div className="flex flex-col items-center justify-center h-5">
    //           <div className="w-1 h-1 bg-gray-600 rounded-full mb-0.5"></div>
    //           <div className="w-1 h-1 bg-gray-600 rounded-full mb-0.5"></div>
    //           <div className="w-1 h-1 bg-gray-600 rounded-full"></div>
    //         </div>
    //       </button>

    //       {/* Dropdown Menu */}
    //       {activeMenu === value && (
    //         <div className="absolute right-0 mt-1 w-32 bg-white rounded-md shadow-lg z-10 py-1 border border-gray-200"
    //              onClick={(e) => e.stopPropagation()}
    //         >
    //           <button
    //             className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
    //             onClick={(e) => {
    //               e.stopPropagation();
    //               handleEdit(row);
    //               setActiveMenu(null);
    //             }}
    //           >
    //             Edit
    //           </button>

    //           <div className="px-4 py-2">
    //             <ToggleSwitch
    //               showLabel={true}
    //               checked={row.isActive}
    //               onChange={(isActive) => {
    //                 handleToggleActive(row.routeId as string, isActive);
    //                 setActiveMenu(null);
    //               }}
    //             />
    //           </div>
    //         </div>
    //       )}
    //     </div>
    //   ),
    // }
    {
      header: "Actions",
      dataKey: "routeId",
      align: "center",
      render: (value, row) => (
        <div
          className="relative ml-2"
          ref={activeMenu === value ? menuRef : null}
          onClick={(e) => e.stopPropagation()} // Prevent row click when interacting with menu
        >
          <button
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100"
            onClick={(e) => {
              e.stopPropagation();
              setActiveMenu(activeMenu === value ? null : (value as string | null));
            }}
          >
            <div className="flex flex-col items-center justify-center h-5">
              <div className="w-1 h-1 bg-gray-600 rounded-full mb-0.5"></div>
              <div className="w-1 h-1 bg-gray-600 rounded-full mb-0.5"></div>
              <div className="w-1 h-1 bg-gray-600 rounded-full"></div>
            </div>
          </button>

          {/* Dropdown Menu */}
          {activeMenu === value && (
            <div className="absolute right-0 mt-1 w-32 bg-white rounded-md shadow-lg z-10 py-1 border border-gray-200"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(row);
                  setActiveMenu(null);
                }}
              >
                Edit
              </button>

              <div className="px-4 py-2">
                <ToggleSwitch
                  showLabel={true}
                  checked={row.isActive}
                  onChange={(isActive) => {
                    handleToggleActive(row.routeId as string, isActive);
                    setActiveMenu(null);
                  }}
                />
              </div>
            </div>
          )}
        </div>
      ),
    }
  ];

  const handleEdit = (item: RouteData) => {
    navigate(`edit/${item.routeId}`);
  };

  const handleDelete = (item: RouteData) => {
    if (window.confirm(`Are you sure you want to delete ${item.routeName}?`)) {
      deleteRoute(item.routeId);
    }
  };

  const deleteRoute = async (routeId: string) => {
    try {
      const response: any = await apiService.putApi(`${MASTER_URL}/route/status-route`, {
        routeId: routeId,
        isActive: 0
      });
      if (response.status === "200") {
        getRoutesData();
      }
    } catch (error) {
      console.error("Error deleting route:", error);
    }
  };

  const getRoutesData = async (isLoadingMore = false) => {
    if (!hasMoreData && isLoadingMore) return;

    setLoading(true);
    try {
      const response: any = await apiService.getApi(
        `${MASTER_URL}/route/get-route?page=${currentPage}&limit=${pageSize}&search=${search}&status=${active ? 1 : 0}`
      );

      if (response.status === "200") {
        const formattedData = response.body.data.map((route: any) => ({
          routeId: route.routeId,
          routeName: route.name,
          pickupPoint: route.pickupPoint,
          loadingPoint: route.loadingPoint,
          unloadingPoint: route.unloadingPoint,
          clearancePoint: route.clearancePoint,
          isActive: route?.isActive === 1
        }));

        const totalRecords = parseInt(response.body.pagination?.totalRecords) || 0;
        const currentLoadedItems = isLoadingMore
          ? routesData.length + formattedData.length
          : formattedData.length;

        setHasMoreData(currentLoadedItems < totalRecords);
        setRoutesData(prevData =>
          isLoadingMore ? [...prevData, ...formattedData] : formattedData
        );
        setTotalItems(totalRecords);
      }
    } catch (error) {
      console.error("Error fetching routes data:", error);
      setHasMoreData(false);
    } finally {
      setLoading(false);
    }
  };

  const handleLoadMore = () => {
    if (hasMoreData) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      getRoutesData(true);
    }
  };

  useEffect(() => {
    setHasMoreData(true);
    setCurrentPage(1);
    getRoutesData();
  }, [search, entityId, active]);

  const handleRowClick = (item: RouteData) => {
    if (active && item.isActive) {
      navigate(`view/${item.routeId}`);
    }
  };

  const handleAdd = () => {
    navigate("add");
  };

  return (
    <div className="">
      <Header
        icon={routes}
        title="Routes"
        toggleComponent={
          <div className="flex items-end gap-2 ml-[450px]">
            <ToggleActive
              onChange={(isActive: boolean) => {
                setActive(isActive); // Update the state
                console.log(isActive ? "active 1" : "inactive 0");
              }}
            />
          </div>
        }
        showSearch={true}
        setSearch={setSearch}
      >
        <div>
          <CustomButton label="" onClick={handleAdd} icon={Plus} />
        </div>
      </Header>

      <AdminCointainer>
        <CustomTable<RouteData>
          columns={columns}
          data={routesData}
          onRowClick={handleRowClick}
          loading={loading}
          onLoadMore={handleLoadMore}
        />
      </AdminCointainer>
    </div>
  );
};

export default RoutesPage;